export default __webpack_public_path__ + "static/media/regulatory--no-right-turn--g1.6e467745.png";